import { ReactComponent as BorderStyleIcon } from 'assets/icons/border_style.svg';
import { useTranslation } from 'react-i18next';

import { DropdownPopover } from '../../ToolbarPopover';
import { BORDER_STYLE_OPTIONS } from './BorderStyleSelect.config';
import { BorderStyleProps } from './BorderStyleSelect.types';

export const BorderStyleSelect = ({ onChange, value }: BorderStyleProps) => {
  const { t } = useTranslation('editor_toolbar', { useSuspense: false, keyPrefix: 'border' });
  const selectedIndex = BORDER_STYLE_OPTIONS.findIndex((option) => option.value === value);

  return (
    <DropdownPopover
      selectedIndex={selectedIndex}
      options={BORDER_STYLE_OPTIONS}
      toolbarIcon={<BorderStyleIcon />}
      label={t('borderStyle.label')}
      onSelect={onChange}
    />
  );
};
